// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__3DyiP","loaderWrapper":"Loader_loaderWrapper__3Kvva","fadeInOut":"Loader_fadeInOut__K_4LU"};